import { createFileRoute } from '@tanstack/react-router';

/**
 * EB Statistics Route Definition
 * Component is loaded from route.lazy.tsx for automatic code splitting
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/statistics/eb')({
  // No beforeLoad - parent _protected handles auth
});
